import { SharedSlice } from 'src/components/slice'
import { StateCreator } from 'zustand'
import {
  convertLinesToOrderTemplate,
  convertLinesToPurchaseOrders,
} from './helpers/helper'
import { IOrderTemplate, IPurchaseOrder } from '$models'
import { purchaseOrderService } from '$services'
import { exceptionMessageHandler } from '$utils'
import useStockStore from '../../../store'

export interface AddPurchaseOrdersSlice extends AddPurchaseOrdersState {
  resetAddPurchaseOrdersSlice: () => void

  generatePurchaseOrders: (
    orderedBy: string,
    creditRequest?: boolean
  ) => Promise<IPurchaseOrder[] | null>

  saveOrderTemplate: (
    templateName: string,
    creditRequest?: boolean
  ) => Promise<IOrderTemplate | null>
}
interface AddPurchaseOrdersState {}

const initialOutstandingOrdersState: AddPurchaseOrdersState = {}

export const purchaseOrderSlice: StateCreator<
  AddPurchaseOrdersSlice & SharedSlice,
  [],
  [],
  AddPurchaseOrdersSlice
> = (set) => ({
  ...initialOutstandingOrdersState,

  resetAddPurchaseOrdersSlice: () => set(initialOutstandingOrdersState),

  generatePurchaseOrders: async (orderedBy, creditRequest = false) => {
    const { purchaseOrderUi } = useStockStore.getState()

    const notes = purchaseOrderUi?.notes
    const purchaseOrderLines = purchaseOrderUi?.lines

    if (!purchaseOrderLines) return null

    const purchaseOrders = convertLinesToPurchaseOrders(
      purchaseOrderLines,
      orderedBy,
      notes,
      creditRequest
    )

    try {
      const updatedPurchaseOrder =
        await purchaseOrderService.createPurchaseOrders(purchaseOrders)

      return updatedPurchaseOrder
    } catch (error) {
      exceptionMessageHandler(error, 'Failed to generate Purchase Orders')
      return null
    }
  },

  saveOrderTemplate: async (templateName, creditRequest = false) => {
    const { purchaseOrderUi } = useStockStore.getState()
    const { suppliers, items, units } = useStockStore.getState()

    const purchaseOrderLines = purchaseOrderUi?.lines

    if (!purchaseOrderLines) return null

    const orderTemplates = convertLinesToOrderTemplate(
      purchaseOrderLines,
      templateName,
      suppliers,
      items,
      units,
      creditRequest
    )

    try {
      const updatedOrderTemplate =
        await purchaseOrderService.createOrderTemplate(orderTemplates)

      return updatedOrderTemplate
    } catch (error) {
      exceptionMessageHandler(error, 'Failed to save Order Template')
      return null
    }
  },
})

export default purchaseOrderSlice
